import { Badge as BadgeWrapper } from './styled';

const STATUS_LIST = {
  SUSPENDED: [1, 'STATUS_SUSPENDED'],
  DELISTED: [2, 'STATUS_DELISTED'],
};

function Badge({ status }: { status: string | number }) {
  const isDelisted = STATUS_LIST.DELISTED.includes(status);
  const isSuspended = STATUS_LIST.SUSPENDED.includes(status);

  const renderBadge = (companyStatus: string) => (
    <BadgeWrapper>
      <span>{companyStatus}</span>
    </BadgeWrapper>
  );

  if (isDelisted) {
    return renderBadge('Delisted');
  }

  if (isSuspended) {
    return renderBadge('Suspended');
  }

  return null;
}

export default Badge;
